var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroup203X(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 48,
    viewBox: "0 0 44 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H44V48L22 44L0 48V0Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4452 28.35V27.02H17.3992V23.366H20.6892V22.05H17.3992V18.858H21.0952V17.542H11.2112V18.858H15.9292V27.02H14.0532V20.762H12.5972V27.02H10.7492V28.35H21.4452ZM31.6655 22.204V17.304H24.1335V22.204H31.6655ZM33.2055 28.728V23.072H28.2215V28.91H29.7055V28.042H31.7215V28.728H33.2055ZM27.4795 28.728V23.072H22.5795V28.91H24.0775V28.042H25.9955V28.728H27.4795ZM25.6315 18.662H30.1815V20.846H25.6315V18.662ZM29.7055 24.43H31.7215V26.992H29.7055V24.43ZM24.0775 24.43H25.9955V26.992H24.0775V24.43Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 44L22 40L44 44V48L22 44L0 48V44Z",
    fill: "#3F7ECE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup203X);
export default __webpack_public_path__ + "static/media/Group 20@3x.90bdef99d439cdd73ecacb96604a0609.svg";
export { ForwardRef as ReactComponent };